import { CLIENT_MESSAGE, type AbilityMessage } from "@mucki/shared";
import type { ZoneRoom } from "./stateSync.js";

export interface AbilitySender {
  send(message: AbilityMessage): void;
}

/** The client renders no outcome of its own — the server decides and replies. */
export function createAbilitySender(room: ZoneRoom): AbilitySender {
  return {
    send: (message) => room.send(CLIENT_MESSAGE.ability, message),
  };
}
